import CustomerPayment from "./components/CustomerPayment";

export default CustomerPayment;
